"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _stores = require("@seedlang/stores");
var _models = require("@seedlang/models");
var _serializr = require("serializr");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewCreateWrapper = function ReviewCreateWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;
  var ReviewCreateWrapperComponent = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function ReviewCreateWrapperComponent() {
      var _this;
      _classCallCheck(this, ReviewCreateWrapperComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, ReviewCreateWrapperComponent, [].concat(args));
      _initializerDefineProperty(_this, "reviewCreateMode", _descriptor, _this);
      _initializerDefineProperty(_this, "word", _descriptor2, _this);
      _initializerDefineProperty(_this, "selectedDeckId", _descriptor3, _this);
      _initializerDefineProperty(_this, "cardTypeIds", _descriptor4, _this);
      _initializerDefineProperty(_this, "reviewCreatedMessage", _descriptor5, _this);
      _initializerDefineProperty(_this, "reviewImportReport", _descriptor6, _this);
      _initializerDefineProperty(_this, "numberCards", _descriptor7, _this);
      _initializerDefineProperty(_this, "frontText", _descriptor8, _this);
      _initializerDefineProperty(_this, "backText", _descriptor9, _this);
      _initializerDefineProperty(_this, "note", _descriptor0, _this);
      _initializerDefineProperty(_this, "showReviewNoteInput", _descriptor1, _this);
      _initializerDefineProperty(_this, "wordSearchValue", _descriptor10, _this);
      _initializerDefineProperty(_this, "completedWordSearchValue", _descriptor11, _this);
      _initializerDefineProperty(_this, "wordSearchFocused", _descriptor12, _this);
      _initializerDefineProperty(_this, "wordSearchKey", _descriptor13, _this);
      _initializerDefineProperty(_this, "showSpinner", _descriptor14, _this);
      _initializerDefineProperty(_this, "importFile", _descriptor15, _this);
      _initializerDefineProperty(_this, "importCardType", _descriptor16, _this);
      _initializerDefineProperty(_this, "importSeparator", _descriptor17, _this);
      _initializerDefineProperty(_this, "importHasHeaderRow", _descriptor18, _this);
      _initializerDefineProperty(_this, "importFileInputKey", _descriptor19, _this);
      _initializerDefineProperty(_this, "reviewCardsForWord", _descriptor20, _this);
      _initializerDefineProperty(_this, "showReviewCardsForWordSpinner", _descriptor21, _this);
      _this.reviewCreateSessionId = "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 10));
      _this.wordSearchRequest = null;
      _this.wordSearchTimeout = null;
      _this.reviewCardsForWordRequest = null;
      _this.reviewCardsForWordRequestId = 0;
      _this.reviewCardsForWordStore = function () {
        var store = new _stores.RootStore();
        store.config = {
          model: _models.Card,
          deserialize: true,
          GET: {
            index: '/cards'
          }
        };
        return store;
      }();
      _this.reviewCreateSource = function () {
        if (_this.reviewCreateMode === 'import') {
          return 'import';
        }
        if (_this.reviewCreateMode === 'custom' && (0, _utils.isPresent)(_this.wordSearchValue)) {
          return 'dictionary_search_to_custom';
        }
        return _this.reviewCreateMode;
      };
      _this.reviewCreateEventParams = function () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _objectSpread({
          review_create_session_id: _this.reviewCreateSessionId,
          review_create_mode: _this.reviewCreateMode,
          review_create_source: _this.reviewCreateSource(),
          is_custom_review: _this.userSubmission,
          target_language_id: _state.AppUI.targetLanguageId,
          has_word_search: (0, _utils.isPresent)(_this.wordSearchValue)
        }, params);
      };
      _this.trackReviewCreateEvent = function (eventType) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _state.AppUI.createEvent(eventType, _this.reviewCreateEventParams(params));
      };
      _this.reviewCreateCardTypeSlug = function (cardTypeId) {
        var cardTypeSlugs = {
          'b6813ff6-c5df-4dd5-b9bc-202be20bfa8c': 'vocab_word_translate',
          'a677c94d-8345-46bd-a837-efea27bafd95': 'vocab_word_comprehend',
          'ea744c6b-add2-4414-8755-0a7a9e90e3ad': 'vocab_word_multiple_choice',
          'bf2b0984-ddf0-4e88-ae95-4fb5a309370c': 'gender',
          '19a422d1-1622-440b-b4d0-03205bfd29c8': 'plural',
          '42593191-a5f0-40ce-a584-7c653dd08c97': 'conjugation',
          '88631b6e-0a8c-400a-9be0-5b84878f652e': 'user_submission'
        };
        return cardTypeSlugs[cardTypeId];
      };
      _this.trackAddedReviews = function () {
        var cardTypeIds = _this.userSubmission ? ['88631b6e-0a8c-400a-9be0-5b84878f652e'] : _this.cardTypeIds;
        cardTypeIds.filter(Boolean).forEach(function (cardTypeId) {
          _this.trackReviewCreateEvent('reviews - add review', {
            review_creation_source: _this.userSubmission ? 'review_create_custom' : "review_create_".concat(_this.reviewCreateSource()),
            card_type: _this.reviewCreateCardTypeSlug(cardTypeId),
            deck_id: _this.deckId,
            language_id: _state.AppUI.targetLanguageId
          });
        });
      };
      _this.toggleConvertCardSubmissions = function () {
        var newValue = !_state.AppUI.user['convertCardSubmissions'];
        _state.AppUI.user.set('convertCardSubmissions', newValue);
        _state.AppUI.authUserStore.update({
          data: {
            convert_card_submissions: newValue
          }
        }, _lodash.noop);
      };
      _this.abortWordSearchRequest = function () {
        var _this$wordSearchReque;
        if ((_this$wordSearchReque = _this.wordSearchRequest) !== null && _this$wordSearchReque !== void 0 && _this$wordSearchReque.abort) {
          _this.wordSearchRequest.abort();
        }
        _this.wordSearchRequest = null;
      };
      _this.abortReviewCardsForWordRequest = function () {
        var _this$reviewCardsForW;
        if ((_this$reviewCardsForW = _this.reviewCardsForWordRequest) !== null && _this$reviewCardsForW !== void 0 && _this$reviewCardsForW.abort) {
          _this.reviewCardsForWordRequest.abort();
        }
        _this.reviewCardsForWordRequest = null;
      };
      _this.clearReviewCardsForWord = function () {
        _this.reviewCardsForWordRequestId += 1;
        _this.abortReviewCardsForWordRequest();
        _this.reviewCardsForWord = [];
        _this.showReviewCardsForWordSpinner = false;
      };
      _this.reviewDeckNameForCard = function (deckId) {
        var _AppUI$reviewDeckStor;
        var reviewDeckOption = (_state.AppUI.reviewDeckOptions || []).find(function (item) {
          return String(item[0]) === String(deckId);
        });
        if (reviewDeckOption) {
          return reviewDeckOption[1];
        }
        var reviewDeck = (((_AppUI$reviewDeckStor = _state.AppUI.reviewDeckStore) === null || _AppUI$reviewDeckStor === void 0 ? void 0 : _AppUI$reviewDeckStor.indexData) || []).find(function (item) {
          return String(item.id) === String(deckId);
        });
        return (reviewDeck === null || reviewDeck === void 0 ? void 0 : reviewDeck.name) || 'Review Deck';
      };
      _this.formatReviewAfterForCard = function (reviewAfter) {
        var _AppUI$user;
        if (!reviewAfter) {
          return '-';
        }
        var reviewsDueAtBeginningOfDay = ((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.reviewsDueAtBeginningOfDay) !== false;
        if (reviewsDueAtBeginningOfDay) {
          return "".concat(reviewAfter.fullTextFormattedDateWithYear).concat(reviewAfter.relativeDays ? " (".concat(reviewAfter.relativeDays, ")") : '');
        }
        return "".concat(reviewAfter.formattedDateWithYearAndTime || '-').concat(reviewAfter.relativeTime ? " (".concat(reviewAfter.relativeTime, ")") : '');
      };
      _this.reviewCardIsPastDue = function (card) {
        var _card$reviewAfter, _card$reviewAfter2, _AppUI$user2;
        var reviewAfterDate = (card === null || card === void 0 || (_card$reviewAfter = card.reviewAfter) === null || _card$reviewAfter === void 0 ? void 0 : _card$reviewAfter.dateObj) || (card === null || card === void 0 || (_card$reviewAfter2 = card.reviewAfter) === null || _card$reviewAfter2 === void 0 ? void 0 : _card$reviewAfter2.date);
        if (!reviewAfterDate) {
          return false;
        }
        var now = new Date();
        var reviewsDueAtBeginningOfDay = ((_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.reviewsDueAtBeginningOfDay) !== false;
        var cutoff = reviewsDueAtBeginningOfDay ? new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999) : now;
        return new Date(reviewAfterDate) < cutoff;
      };
      _this.fetchReviewCardsForWord = function (wordId) {
        var _AppUI$user3;
        _this.clearReviewCardsForWord();
        if ((0, _utils.isBlank)(wordId) || (0, _utils.isBlank)((_AppUI$user3 = _state.AppUI.user) === null || _AppUI$user3 === void 0 ? void 0 : _AppUI$user3.id)) {
          return;
        }
        _this.showReviewCardsForWordSpinner = true;
        _this.reviewCardsForWordRequestId += 1;
        var requestId = _this.reviewCardsForWordRequestId;
        var request = _this.reviewCardsForWordStore.getIndex({
          filters: {
            user_id: _state.AppUI.user.id,
            word_id: wordId
          },
          queryStrings: {
            my_reviews: true
          },
          limit: 100,
          sort: 'review_after',
          failureCallback: function failureCallback() {
            if (requestId !== _this.reviewCardsForWordRequestId) {
              return;
            }
            _this.showReviewCardsForWordSpinner = false;
          },
          onRequestError: function onRequestError() {
            if (requestId !== _this.reviewCardsForWordRequestId) {
              return;
            }
            _this.showReviewCardsForWordSpinner = false;
          }
        }, function (resp) {
          if (requestId !== _this.reviewCardsForWordRequestId) {
            return;
          }
          _this.reviewCardsForWordStore.afterGetIndex(resp);
          _this.reviewCardsForWord = _toConsumableArray(_this.reviewCardsForWordStore.indexData);
          _this.showReviewCardsForWordSpinner = false;
        });
        _this.reviewCardsForWordRequest = request;
      };
      _this.onResetReviewCardForWord = function (cardId) {
        var _this$word;
        var card = _this.reviewCardsForWord.find(function (item) {
          return String(item.id) === String(cardId);
        });
        var wordId = (_this$word = _this.word) === null || _this$word === void 0 ? void 0 : _this$word.id;
        if (!(card !== null && card !== void 0 && card.id) || (0, _utils.isBlank)(wordId)) {
          return;
        }
        card.onResetReview();
        _state.DeckUI.updateSpacedRepetitionFields(card);
        _state.AppUI.cardStore.destroyReviews({
          ids: {
            cardId: card.id
          }
        }, function () {
          _this.fetchReviewCardsForWord(wordId);
        });
      };
      _this.onManageReviewCardForWord = function (cardId) {
        if ((0, _utils.isBlank)(cardId)) {
          return;
        }
        var card = _this.reviewCardsForWord.find(function (item) {
          return String(item.id) === String(cardId);
        });
        if (card) {
          _state.AppUI.cardStore.showData = card;
        }
        _state.AppUI.routeStore.routeToNamed('reviews.show', {
          page: 1,
          cardId: cardId
        });
      };
      _this.onDeleteReviewCardForWord = function (cardId) {
        var _this$word2;
        var wordId = (_this$word2 = _this.word) === null || _this$word2 === void 0 ? void 0 : _this$word2.id;
        if ((0, _utils.isBlank)(cardId) || (0, _utils.isBlank)(wordId)) {
          return;
        }
        _state.AppUI.set('reloadReviewDecks', true);
        _state.AppUI.cardStore.destroy({
          ids: {
            cardId: cardId
          }
        }, function () {
          _this.fetchReviewCardsForWord(wordId);
        });
      };
      _this.canUseWindowHash = function () {
        return typeof window !== 'undefined' && window.location && window.history;
      };
      _this.reviewCreateModeFromHash = function () {
        if (!_this.canUseWindowHash()) {
          return null;
        }
        var hash = window.location.hash.replace('#', '');
        if (hash === 'dictionary' || hash === 'from-dictionary') {
          return 'dictionary';
        }
        if (hash === 'custom' || hash === 'custom-review') {
          return 'custom';
        }
        if (hash === 'import') {
          return 'import';
        }
        return null;
      };
      _this.applyReviewCreateModeFromHash = function () {
        var reviewCreateMode = _this.reviewCreateModeFromHash();
        if (reviewCreateMode && reviewCreateMode !== _this.reviewCreateMode) {
          _this.onSetReviewCreateMode(reviewCreateMode, false);
        }
      };
      _this.updateReviewCreateModeHash = function (reviewCreateMode) {
        if (!_this.canUseWindowHash()) {
          return;
        }
        if (!window.location.hash || window.location.hash.replace('#', '') !== reviewCreateMode) {
          window.history.pushState(null, '', "#".concat(reviewCreateMode));
        }
      };
      _this.applyInitialReviewWord = function () {
        if ((0, _utils.isBlank)(_this.props.initialReviewWord)) {
          return;
        }
        var initialReviewWord = "".concat(_this.props.initialReviewWord).trim();
        if ((0, _utils.isBlank)(initialReviewWord)) {
          return;
        }
        _this.reviewCreateMode = 'dictionary';
        _this.word = null;
        _this.frontText = '';
        _this.backText = '';
        _this.note = '';
        _this.showReviewNoteInput = false;
        _this.wordSearchValue = initialReviewWord;
        _this.completedWordSearchValue = null;
        var filters = {
          target_text: "".concat(initialReviewWord, "~"),
          simple: false,
          root: true,
          word_type_id: true,
          en_sources_count: '!0',
          language_id: _state.AppUI.targetLanguageId
        };
        _state.AppUI.wordSearchStore.getIndex({
          filters: filters,
          queryStrings: {
            vocab_list: true
          }
        }, function (resp) {
          if (_this.wordSearchValue !== initialReviewWord) {
            return;
          }
          _state.AppUI.wordSearchStore.afterGetIndex(resp);
          _this.completedWordSearchValue = initialReviewWord;
        });
      };
      _this.onSubmit = function () {
        if (_this.reviewCreateMode === 'import' && !_this.canImportReviews) {
          return;
        }
        if (!_this.disableSubmit) {
          _this.trackReviewCreateEvent('reviews - submit create review');
          _this.showSpinner = true;
          _this.reviewCreatedMessage = null;
          _this.reviewImportReport = null;
          _stores.ServerStore.clearMessages();
          _state.AppUI.set('reloadReviewDecks', true);
          if (_this.reviewCreateMode === 'import') {
            var _data = new FormData();
            _data.append('data[deck_id]', _this.deckId || '');
            _data.append('data[language_id]', _state.AppUI.targetLanguageId || '');
            _data.append('data[import_card_type]', _this.importCardType);
            _data.append('data[import_separator]', _this.importSeparator);
            _data.append('data[import_has_header_row]', _this.importHasHeaderRow);
            _data.append('data[import_file]', _this.importFile);
            _state.DeckUI.cardStore.multipartCreate({
              data: _data,
              failureCallback: _this.onSubmitFailure
            }, _this.afterSubmit);
            return;
          }
          var data = {
            interface_source: 'review-create',
            deckId: _this.deckId,
            languageId: _state.AppUI.targetLanguageId,
            userId: _state.DeckUI.user.id,
            userSubmission: _this.userSubmission,
            frontText: (0, _utils.isBlank)(_this.word) ? _this.frontText : null,
            backText: (0, _utils.isBlank)(_this.word) ? _this.backText : null,
            note: (0, _utils.isPresent)(_this.note) ? _this.note : null,
            wordId: (0, _utils.isPresent)(_this.word) ? _this.word.id : null,
            cardTypeIds: _this.userSubmission ? ['88631b6e-0a8c-400a-9be0-5b84878f652e'] : _this.cardTypeIds
          };
          _state.DeckUI.cardStore.create({
            data: data,
            failureCallback: _this.onSubmitFailure
          }, _this.afterSubmit);
        }
      };
      _this.setReviewingForWordInSearchResults = function (wordId) {
        if ((0, _utils.isBlank)(wordId)) {
          return;
        }
        var word = (_state.AppUI.wordSearchStore.indexData || []).find(function (item) {
          return String(item.id) === String(wordId);
        });
        if (!word) {
          return;
        }
        if (word.set) {
          word.set('reviewing', true);
        } else {
          word.reviewing = true;
        }
      };
      _this.afterSubmit = function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var createdCount = _this.createdCountForResponse(resp);
        if (_state.AppUI.user.reviewCardsCount === 0) {
          _state.AppUI.loadUser();
        }
        _this.showSpinner = false;
        if (!(_this.reviewCreateMode === 'import' && resp.queued)) {
          _state.AppUI.user.set('reviewCardsCount', _state.AppUI.user.reviewCardsCount + createdCount);
        }
        if (_this.reviewCreateMode === 'import') {
          if (resp.queued) {
            _this.reviewImportReport = null;
            _this.reviewCreatedMessage = _this.reviewImportQueuedMessageForResponse(resp);
          } else {
            _this.reviewCreatedMessage = null;
            _this.reviewImportReport = _this.reviewImportReportForResponse(resp);
          }
        } else {
          var _this$word3;
          _this.reviewImportReport = null;
          _this.reviewCreatedMessage = _this.reviewCreatedMessageForResponse(resp, createdCount);
          _this.trackAddedReviews();
          _this.setReviewingForWordInSearchResults((_this$word3 = _this.word) === null || _this$word3 === void 0 ? void 0 : _this$word3.id);
        }
        _this.onCancel({
          preserveWordSearch: _this.reviewCreateMode === 'dictionary'
        });
        if (_this.reviewCreateMode !== 'import') {
          setTimeout(_this.removeReviewCreatedMessage, 5000);
        }
      };
      _this.onSubmitFailure = function () {
        _this.showSpinner = false;
      };
      _this.removeReviewCreatedMessage = function () {
        _this.reviewCreatedMessage = null;
      };
      _this.removeReviewImportReport = function () {
        _this.reviewImportReport = null;
      };
      _this.swapFrontAndBack = function () {
        var front = _this.frontText;
        var back = _this.backText;
        _this.frontText = back;
        _this.backText = front;
      };
      _this.onSetReviewCreateMode = function (reviewCreateMode) {
        var updateHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var previousReviewCreateMode = _this.reviewCreateMode;
        if (reviewCreateMode === 'custom' && (0, _utils.isBlank)(_this.frontText) && (0, _utils.isPresent)(_this.wordSearchValue)) {
          _this.frontText = "".concat(_this.wordSearchValue).trim();
        }
        if (reviewCreateMode === 'dictionary') {
          _this.frontText = '';
          _this.backText = '';
        }
        if (reviewCreateMode !== 'import') {
          _this.importFile = null;
          _this.importFileInputKey += 1;
        }
        _this.reviewCreateMode = reviewCreateMode;
        _this.word = null;
        _this.clearReviewCardsForWord();
        _this.note = '';
        _this.showReviewNoteInput = false;
        if (updateHash) {
          _this.updateReviewCreateModeHash(reviewCreateMode);
        }
        if (previousReviewCreateMode !== reviewCreateMode && reviewCreateMode === 'custom') {
          _this.trackReviewCreateEvent('reviews - view custom create review', {
            previous_review_create_mode: previousReviewCreateMode
          });
        }
      };
      _this.onSetShowAddWord = function (showAddWord) {
        _this.onSetReviewCreateMode(showAddWord ? 'dictionary' : 'custom');
      };
      _this.onSetFrontText = function (frontText) {
        _this.frontText = frontText;
      };
      _this.onSetBackText = function (backText) {
        _this.backText = backText;
      };
      _this.onSetNote = function (note) {
        _this.note = note;
      };
      _this.onShowReviewNoteInput = function () {
        _this.showReviewNoteInput = true;
      };
      _this.onSetDeckId = function (deckId) {
        _this.selectedDeckId = deckId;
      };
      _this.onSetWord = function (word) {
        var _this$word4;
        if (!word) {
          _this.word = null;
          _this.clearReviewCardsForWord();
          _this.wordSearchValue = null;
          _this.completedWordSearchValue = null;
          _this.onCancel();
          return;
        }
        if (word instanceof _models.Word) {
          _this.word = word;
        } else {
          var serializedWord = word.attributes || word;
          _this.word = (0, _serializr.deserialize)(_models.Word, serializedWord);
        }
        _this.fetchReviewCardsForWord((_this$word4 = _this.word) === null || _this$word4 === void 0 ? void 0 : _this$word4.id);
        _this.trackReviewCreateEvent('reviews - select dictionary review word');
      };
      _this.onBackToSearchResults = function () {
        _this.word = null;
        _this.clearReviewCardsForWord();
        _this.note = '';
        _this.showReviewNoteInput = false;
        _this.cardTypeIds = ['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c'];
      };
      _this.onSetCardTypeId = function (cardTypeId) {
        if (_this.cardTypeIds.includes(cardTypeId)) {
          _this.cardTypeIds = _this.cardTypeIds.filter(function (id) {
            return id !== cardTypeId;
          });
        } else {
          _this.cardTypeIds.push(cardTypeId);
        }
      };
      _this.onCreateWord = function () {
        _this.onSetReviewCreateMode('custom');
      };
      _this.onCancel = function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$preserveWordSear = _ref.preserveWordSearch,
          preserveWordSearch = _ref$preserveWordSear === void 0 ? false : _ref$preserveWordSear,
          _ref$preserveSelected = _ref.preserveSelectedWord,
          preserveSelectedWord = _ref$preserveSelected === void 0 ? false : _ref$preserveSelected;
        var previousWord = _this.word;
        var previousWordSearchValue = _this.wordSearchValue;
        var previousCompletedWordSearchValue = _this.completedWordSearchValue;
        _this.frontText = '';
        _this.backText = '';
        _this.note = '';
        _this.showReviewNoteInput = false;
        _this.word = preserveSelectedWord ? previousWord : null;
        if (!preserveSelectedWord) {
          _this.clearReviewCardsForWord();
        }
        _this.cardTypeIds = ['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c'];
        _this.deckIds = [];
        _this.wordSearchValue = preserveWordSearch ? previousWordSearchValue : null;
        _this.completedWordSearchValue = preserveWordSearch ? previousCompletedWordSearchValue : null;
        _this.importFile = null;
        _this.importCardType = 'translation';
        _this.importSeparator = 'comma';
        _this.importHasHeaderRow = true;
        _this.importFileInputKey += 1;
      };
      _this.onSetWordSearchValue = function (val) {
        _this.onUpdateWordSearchQuery(val);
      };
      _this.onChangeWordSearchValue = function (val) {
        _this.onUpdateWordSearchQuery(val);
      };
      _this.onUpdateWordSearchQuery = function (val) {
        var nextWordSearchValue = "".concat(val || '').replace(/^\s+/, '');
        var normalizedWordSearchValue = (0, _utils.isPresent)(nextWordSearchValue) ? nextWordSearchValue : null;
        _this.wordSearchValue = normalizedWordSearchValue;
        _this.completedWordSearchValue = null;
        _this.word = null;
        _this.clearReviewCardsForWord();
        _this.note = '';
        _this.showReviewNoteInput = false;
        _this.cardTypeIds = ['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c'];
        clearTimeout(_this.wordSearchTimeout);
        _this.abortWordSearchRequest();
        _state.AppUI.wordSearchStore.clearIndexData();
        if ((0, _utils.isBlank)(normalizedWordSearchValue)) {
          return;
        }
        _this.wordSearchTimeout = setTimeout(function () {
          var searchValue = normalizedWordSearchValue;
          var filters = {
            target_text: "".concat(searchValue, "~"),
            simple: false,
            root: true,
            word_type_id: true,
            en_sources_count: '!0',
            language_id: _state.AppUI.targetLanguageId
          };
          var request = _state.AppUI.wordSearchStore.getIndex({
            filters: filters,
            queryStrings: {
              vocab_list: true
            }
          }, function (resp) {
            if (_this.wordSearchRequest !== request) {
              return;
            }
            _this.wordSearchRequest = null;
            if (_this.wordSearchValue !== searchValue) {
              return;
            }
            _state.AppUI.wordSearchStore.afterGetIndex(resp);
            _this.completedWordSearchValue = searchValue;
            var dictionarySearchResultsCount = _state.AppUI.wordSearchStore.indexData.length;
            _state.AppUI.createEvent('vocab - search', {
              context: 'review_create',
              results_count: dictionarySearchResultsCount,
              target_language_id: _state.AppUI.targetLanguageId
            });
            _this.trackReviewCreateEvent('reviews - complete dictionary review search', {
              dictionary_search_has_results: dictionarySearchResultsCount > 0
            });
          });
          _this.wordSearchRequest = request;
        }, 150);
      };
      _this.onInsertWordSearchText = function (textToInsert, caretPosition) {
        var currentValue = _this.wordSearchValue || '';
        var resolvedCaretPosition = Number.isInteger(caretPosition) ? caretPosition : currentValue.length;
        var nextValue = "".concat(currentValue.slice(0, resolvedCaretPosition)).concat(textToInsert).concat(currentValue.slice(resolvedCaretPosition));
        _this.onUpdateWordSearchQuery(nextValue);
      };
      _this.onWordSearchComplete = function (val) {
        _this.completedWordSearchValue = val;
      };
      _this.clearWordSearch = function () {
        _this.abortWordSearchRequest();
        clearTimeout(_this.wordSearchTimeout);
        _this.wordSearchValue = null;
        _this.completedWordSearchValue = null;
        _this.wordSearchKey += 1;
        _this.clearReviewCardsForWord();
        _state.AppUI.wordSearchStore.clearIndexData();
      };
      _this.onBlurWordSearch = function () {
        _this.wordSearchFocused = false;
      };
      _this.onFocusWordSearch = function () {
        _this.wordSearchFocused = true;
      };
      _this.onSetImportFile = function (event) {
        var _event$target$files, _this$importFile, _this$importFile2;
        _this.importFile = ((_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0]) || null;
        if ((_this$importFile = _this.importFile) !== null && _this$importFile !== void 0 && (_this$importFile = _this$importFile.name) !== null && _this$importFile !== void 0 && _this$importFile.toLowerCase().endsWith('.tsv') || ((_this$importFile2 = _this.importFile) === null || _this$importFile2 === void 0 ? void 0 : _this$importFile2.type) === 'text/tab-separated-values') {
          _this.importSeparator = 'tab';
        }
      };
      _this.onSetImportCardType = function (importCardType) {
        _this.importCardType = importCardType;
      };
      _this.onSetImportSeparator = function (importSeparator) {
        _this.importSeparator = importSeparator;
      };
      _this.onSetImportHasHeaderRow = function (importHasHeaderRow) {
        _this.importHasHeaderRow = importHasHeaderRow;
      };
      _this.createdCountForResponse = function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (_this.reviewCreateMode === 'import') {
          return resp.importedCount || 0;
        }
        if (_this.userSubmission || _this.cardTypeIds.length === 1) {
          return 1;
        }
        return _this.cardTypeIds.length;
      };
      _this.reviewCreatedMessageForResponse = function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var createdCount = arguments.length > 1 ? arguments[1] : undefined;
        if (_this.reviewCreateMode === 'import') {
          var skippedCount = resp.skippedCount || 0;
          if (createdCount === 0) {
            return "No reviews were imported. ".concat(skippedCount, " ").concat(skippedCount === 1 ? 'row was' : 'rows were', " skipped.");
          }
          if (skippedCount === 0) {
            return "Imported ".concat(createdCount, " ").concat(createdCount === 1 ? 'review' : 'reviews', ".");
          }
          return "Imported ".concat(createdCount, " ").concat(createdCount === 1 ? 'review' : 'reviews', " and skipped ").concat(skippedCount, " ").concat(skippedCount === 1 ? 'row' : 'rows', ".");
        }
        if (_this.userSubmission || _this.cardTypeIds.length === 1) {
          return 'This card was successfully created.';
        }
        return 'These cards were successfully created.';
      };
      _this.reviewImportReportForResponse = function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
          importedCount: resp.importedCount || 0,
          skippedCount: resp.skippedCount || 0,
          createdCardTypeCounts: resp.createdCardTypeCounts || [],
          failedCards: resp.failedCards || []
        };
      };
      _this.reviewImportQueuedMessageForResponse = function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return resp.message || 'We are creating your reviews in the background. When the import is finished, you will see a notification in the top right corner of the page and the reviews will appear in the "Manage" tab. You may need to refresh the page to see the notification.';
      };
      return _this;
    }
    _inherits(ReviewCreateWrapperComponent, _React$Component);
    return _createClass(ReviewCreateWrapperComponent, [{
      key: "disableSubmit",
      get: function get() {
        if (this.reviewCreateMode === 'import') {
          return !this.canImportReviews || !this.importFile;
        }
        if (this.reviewCreateMode === 'dictionary') {
          return (0, _utils.isBlank)(this.word) || (0, _utils.isBlank)(this.cardTypeIds);
        }
        return !((0, _utils.isPresent)(this.frontText) && (0, _utils.isPresent)(this.backText));
      }
    }, {
      key: "disableCancel",
      get: function get() {
        return (0, _utils.isBlank)(this.word) && (0, _utils.isBlank)(this.frontText) && (0, _utils.isBlank)(this.backText) && (0, _utils.isBlank)(this.note) && !this.importFile;
      }
    }, {
      key: "cardTypeOptions",
      get: function get() {
        var options = [['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c', 'Word Translation'], ['a677c94d-8345-46bd-a837-efea27bafd95', 'Word Comprehension'], ['ea744c6b-add2-4414-8755-0a7a9e90e3ad', 'Word Multiple Choice']];
        if (this.word && this.word.isNoun && !this.word.hideFromGenderTrainer) {
          options.push(['bf2b0984-ddf0-4e88-ae95-4fb5a309370c', 'Gender']);
        }
        if (this.word && this.word.isNoun && !this.word.hideFromPluralTrainer && !this.word.noPlural && this.word.languageId === 'DE') {
          options.push(['19a422d1-1622-440b-b4d0-03205bfd29c8', 'Plural']);
        }
        if (this.word && this.word.isVerb && !this.word.hideFromConjugationTrainer) {
          options.push(['42593191-a5f0-40ce-a584-7c653dd08c97', 'Conjugation']);
        }
        return options;
      }
    }, {
      key: "userSubmission",
      get: function get() {
        return this.reviewCreateMode === 'custom' && (0, _utils.isBlank)(this.word);
      }
    }, {
      key: "showAddWord",
      get: function get() {
        return this.reviewCreateMode === 'dictionary';
      }
    }, {
      key: "showImport",
      get: function get() {
        return this.reviewCreateMode === 'import';
      }
    }, {
      key: "canImportReviews",
      get: function get() {
        var _AppUI$user4, _AppUI$user5, _AppUI$user6;
        return Boolean(((_AppUI$user4 = _state.AppUI.user) === null || _AppUI$user4 === void 0 ? void 0 : _AppUI$user4.anyAdmin) || ((_AppUI$user5 = _state.AppUI.user) === null || _AppUI$user5 === void 0 ? void 0 : _AppUI$user5.hasPermanentMembershipOnSeedlang) || ((_AppUI$user6 = _state.AppUI.user) === null || _AppUI$user6 === void 0 ? void 0 : _AppUI$user6.hasProMembershipOnSeedlang));
      }
    }, {
      key: "showAddGermanWordTab",
      get: function get() {
        return this.reviewCreateMode === 'dictionary';
      }
    }, {
      key: "defaultDeckId",
      get: function get() {
        var _AppUI$filteredReview;
        return (_AppUI$filteredReview = _state.AppUI.filteredReviewDecks) === null || _AppUI$filteredReview === void 0 || (_AppUI$filteredReview = _AppUI$filteredReview.filter(function (item) {
          return item.languageId === _state.AppUI.targetLanguageId;
        })[0]) === null || _AppUI$filteredReview === void 0 ? void 0 : _AppUI$filteredReview.id;
      }
    }, {
      key: "deckId",
      get: function get() {
        if ((0, _utils.isPresent)(this.selectedDeckId)) {
          return this.selectedDeckId;
        } else if ((0, _utils.isPresent)(_state.AppUI.reviewDeckOptions)) {
          return _state.AppUI.reviewDeckOptions[0][0];
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        _state.AppUI.createEvent('reviews - view create reviews');
        this.applyReviewCreateModeFromHash();
        if (this.canUseWindowHash()) {
          window.addEventListener('hashchange', this.applyReviewCreateModeFromHash);
          window.addEventListener('popstate', this.applyReviewCreateModeFromHash);
        }
        this.applyInitialReviewWord();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.createReviewTimestamp !== this.props.createReviewTimestamp || prevProps.initialReviewWord !== this.props.initialReviewWord) {
          this.applyInitialReviewWord();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.abortWordSearchRequest();
        clearTimeout(this.wordSearchTimeout);
        this.abortReviewCardsForWordRequest();
        if (this.canUseWindowHash()) {
          window.removeEventListener('hashchange', this.applyReviewCreateModeFromHash);
          window.removeEventListener('popstate', this.applyReviewCreateModeFromHash);
        }
      }
    }, {
      key: "reviewCardsForWordDetails",
      get: function get() {
        var _this2 = this;
        return this.reviewCardsForWord.map(function (card) {
          var _card$cardType;
          var status = card.retired ? 'Retired' : _this2.reviewCardIsPastDue(card) ? 'Past Due' : 'Caught Up';
          var dueText = card.retired ? null : _this2.formatReviewAfterForCard(card.reviewAfter);
          return {
            id: card.id,
            deckName: _this2.reviewDeckNameForCard(card.deckId),
            cardTypeName: ((_card$cardType = card.cardType) === null || _card$cardType === void 0 ? void 0 : _card$cardType.name) || 'Review Card',
            dueText: dueText,
            status: status
          };
        });
      }
    }, {
      key: "reviewDeckNamesForWord",
      get: function get() {
        return _toConsumableArray(new Set(this.reviewCardsForWordDetails.map(function (item) {
          return item.deckName;
        })));
      }
    }, {
      key: "showWordNotFound",
      get: function get() {
        return this.showAddGermanWordTab && !_state.AppUI.wordSearchStore.showLoadingIcon && (0, _utils.isPresent)(this.wordSearchValue) && this.completedWordSearchValue === this.wordSearchValue && !this.word && !_stores.WordSearchStore.hasIndexData;
      }
    }, {
      key: "swapDisabled",
      get: function get() {
        return !this.frontText && !this.backText;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          reviewDeckOptions: _state.AppUI.reviewDeckOptions,
          canImportReviews: this.canImportReviews,
          word: this.word,
          reviewCreateMode: this.reviewCreateMode,
          showAddWord: this.showAddWord,
          showImport: this.showImport,
          reviewCreatedMessage: this.reviewCreatedMessage,
          reviewImportReport: this.reviewImportReport,
          numberCards: this.numberCards,
          frontText: this.frontText,
          backText: this.backText,
          note: this.note,
          showReviewNoteInput: this.showReviewNoteInput,
          reviewCardsForWord: this.reviewCardsForWord,
          reviewCardsForWordDetails: this.reviewCardsForWordDetails,
          reviewDeckNamesForWord: this.reviewDeckNamesForWord,
          showReviewCardsForWordSpinner: this.showReviewCardsForWordSpinner,
          onResetReviewCardForWord: this.onResetReviewCardForWord,
          onManageReviewCardForWord: this.onManageReviewCardForWord,
          onDeleteReviewCardForWord: this.onDeleteReviewCardForWord,
          deckId: this.deckId,
          disableSubmit: this.disableSubmit,
          onSubmit: this.onSubmit,
          afterSubmit: this.afterSubmit,
          removeReviewCreatedMessage: this.removeReviewCreatedMessage,
          removeReviewImportReport: this.removeReviewImportReport,
          onSetDeckId: this.onSetDeckId,
          onSetReviewCreateMode: this.onSetReviewCreateMode,
          onSetShowAddWord: this.onSetShowAddWord,
          setShowAddWord: this.onSetShowAddWord,
          onSetFrontText: this.onSetFrontText,
          onSetBackText: this.onSetBackText,
          onSetNote: this.onSetNote,
          onShowReviewNoteInput: this.onShowReviewNoteInput,
          onSetWord: this.onSetWord,
          cardTypeOptions: this.cardTypeOptions,
          cardTypeId: this.cardTypeId,
          onSetCardTypeId: this.onSetCardTypeId,
          onCreateWord: this.onCreateWord,
          onCancel: this.onCancel,
          onBackToSearchResults: this.onBackToSearchResults,
          disableCancel: this.disableCancel,
          onSetWordSearchValue: this.onSetWordSearchValue,
          onChangeWordSearchValue: this.onChangeWordSearchValue,
          onUpdateWordSearchQuery: this.onUpdateWordSearchQuery,
          onInsertWordSearchText: this.onInsertWordSearchText,
          onWordSearchComplete: this.onWordSearchComplete,
          wordSearchValue: this.wordSearchValue,
          completedWordSearchValue: this.completedWordSearchValue,
          hasReview: this.hasReview,
          wordSearchFocused: this.wordSearchFocused,
          onBlurWordSearch: this.onBlurWordSearch,
          onFocusWordSearch: this.onFocusWordSearch,
          showAddGermanWordTab: this.showAddGermanWordTab,
          defaultDeckId: this.defaultDeckId,
          showSpinner: this.showSpinner,
          toggleConvertCardSubmissions: this.toggleConvertCardSubmissions,
          showWordNotFound: this.showWordNotFound,
          clearWordSearch: this.clearWordSearch,
          wordSearchKey: this.wordSearchKey,
          swapDisabled: this.swapDisabled,
          swapFrontAndBack: this.swapFrontAndBack,
          deckIds: this.deckIds,
          cardTypeIds: this.cardTypeIds,
          importFile: this.importFile,
          importFileInputKey: this.importFileInputKey,
          importCardType: this.importCardType,
          importSeparator: this.importSeparator,
          importHasHeaderRow: this.importHasHeaderRow,
          onSetImportFile: this.onSetImportFile,
          onSetImportCardType: this.onSetImportCardType,
          onSetImportSeparator: this.onSetImportSeparator,
          onSetImportHasHeaderRow: this.onSetImportHasHeaderRow
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "reviewCreateMode", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'dictionary';
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "selectedDeckId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "cardTypeIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return ['b6813ff6-c5df-4dd5-b9bc-202be20bfa8c'];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "reviewCreatedMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "reviewImportReport", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "numberCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "frontText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "backText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "note", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "showReviewNoteInput", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "wordSearchValue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "completedWordSearchValue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "wordSearchFocused", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "wordSearchKey", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 0;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "importFile", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "importCardType", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'translation';
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "importSeparator", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'comma';
    }
  }), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "importHasHeaderRow", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "importFileInputKey", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 0;
    }
  }), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "reviewCardsForWord", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, "showReviewCardsForWordSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "disableSubmit", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableCancel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableCancel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userSubmission", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userSubmission"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAddWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showAddWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showImport", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showImport"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canImportReviews", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canImportReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAddGermanWordTab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showAddGermanWordTab"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewCardsForWordDetails", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewCardsForWordDetails"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckNamesForWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckNamesForWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordNotFound", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordNotFound"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "swapDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "swapDisabled"), _class2.prototype), _class2)) || _class;
  ReviewCreateWrapperComponent.displayName = 'ReviewCreateWrapper';
  return ReviewCreateWrapperComponent;
};
var _default = exports["default"] = ReviewCreateWrapper;